/**
 * Export vertex units (manufacturing meshes). Scene editing stays in centimeters.
 */

import { fileUnitToSceneCmMultiplier, SCENE_VERTEX_UNIT } from './vertexScaleToScene';

/** Default STL/PLY/OBJ vertex unit for BK exports. */
export const DEFAULT_EXPORT_VERTEX_UNIT = /** @type {const} */ ('mm');

/** @typedef {'mm'|'cm'|'m'} ExportVertexUnit */

/**
 * Scale scene geometry (cm) into export file coordinates.
 *
 * @param {ExportVertexUnit} [exportUnit]
 * @returns {number}
 */
export function sceneCmToExportMultiplier(exportUnit = DEFAULT_EXPORT_VERTEX_UNIT) {
  if (exportUnit === SCENE_VERTEX_UNIT) return 1;
  return fileUnitToSceneCmMultiplier(SCENE_VERTEX_UNIT) / fileUnitToSceneCmMultiplier(exportUnit);
}
